<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PhoneExtListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PhoneExtListing from "@/views/pages/admin/phoneExtension/phoneExtListing";

export default {
    page: {
        title: i18n.t("module.phoneExtension"),
    },
    components: { Layout, PageHeader, PhoneExtListing },
    data() {
        return {
            title: i18n.t("module.phoneExtension"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: '/workplaces',
                },
                {
                    text: i18n.t("module.phoneExtension"),
                    active: true,
                },
            ],
        };
    },
}
</script>
